import { render, staticRenderFns } from "./MisJustificaciones.vue?vue&type=template&id=58e7c16b&"
import script from "./MisJustificaciones.vue?vue&type=script&lang=js&"
export * from "./MisJustificaciones.vue?vue&type=script&lang=js&"
import style0 from "./MisJustificaciones.vue?vue&type=style&index=0&id=58e7c16b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports